export enum LevelMode {
  ADD,
  EDIT,
  DELETE,
}
